/*
  Wrap the hero slideshow around on swipe.

  Dawn's slideshow already loops for the arrows, the dots and autoplay, but a
  swipe is native scrolling with no JavaScript in the path, so it simply stops
  at the last slide. This listens for a further swipe once the track is already
  resting at an end and jumps to the other end.

  Only acts at the boundary, so ordinary slide-to-slide swiping is untouched.
*/
(function () {
  'use strict';

  var EDGE = 2; // px tolerance for "resting at the end"
  var MIN_SWIPE = 40; // px, ignores taps and hesitant drags

  function setUp(track) {
    if (track.dataset.loopBound === 'true') return;
    track.dataset.loopBound = 'true';

    var startX = null;

    function atStart() {
      return track.scrollLeft <= EDGE;
    }

    function atEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - EDGE;
    }

    function jumpTo(left) {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }

    track.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches.length === 1 ? event.touches[0].clientX : null;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      function (event) {
        if (startX === null || !event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(deltaX) < MIN_SWIPE) return;

        // Swiping right-to-left past the last slide returns to the first.
        if (deltaX < 0 && atEnd()) jumpTo(0);
        // And left-to-right before the first slide goes to the last.
        else if (deltaX > 0 && atStart()) jumpTo(track.scrollWidth);
      },
      { passive: true }
    );
  }

  function init() {
    document.querySelectorAll('.hero-slideshow__track').forEach(setUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', init);
})();
